import { render, staticRenderFns } from "./HasTwoColumns.vue?vue&type=template&id=6900b939"
import script from "./HasTwoColumns.vue?vue&type=script&lang=js"
export * from "./HasTwoColumns.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports